import React, { useEffect, useState } from 'react';
import { Bar, Pie } from 'react-chartjs-2';
import { Chart as ChartJS, BarElement, CategoryScale, LinearScale, Title, Tooltip, Legend, ArcElement } from 'chart.js';
import ApiServices from '../config/ApiServices';
import { toast } from "react-toastify";
import { useSelector, useDispatch } from 'react-redux';
import { hideLoader, showLoader } from '../redux/actions/LoaderActions';


ChartJS.register(
    BarElement,
    CategoryScale,
    LinearScale,
    Title,
    Tooltip,
    Legend,
    ArcElement
);

const BatchGraph = ({ avgMarks }) => {
    const dispatch = useDispatch();
    const loading = useSelector((state) => state.loader.loading);
    // const [batches, setBatches] = useState([]);
    // const [avgMarks, setAvgMarks] = useState([]);
    // const [taskStatus, setTaskStatus] = useState([]);

    
    // useEffect(() => {
    //     fetchData();
    // }, []);
    // const fetchData = async () => {
   
    //     try {
    //         const batchRes = await ApiServices.apiRequest("getBatch", { trainerId, status: true });
    //         if (batchRes.data.success) {
    //             const batchData = batchRes.data.data;
    //             setBatches(batchData);

    //             const taskPromises = batchData.map(batch => ApiServices.apiRequest("getTask", { batchId: batch._id }));
    //             const taskRes = await Promise.all(taskPromises);
    //             const tasks = taskRes.flatMap(res => res.data.data);

    //             // Fetch marks for all tasks
    //             const markPromises = tasks.map(task => ApiServices.apiRequest("getMarks", { testId: task._id }));
    //             const markResArray = await Promise.all(markPromises);

    //             // Process the marks data
    //             const allMarks = markResArray.flatMap(res => res.data.data);
    //             const avgMarksData = batchData.map(batch => {
    //                 const batchTasks = tasks.filter(task => task?.batchId?._id === batch._id);
    //                 const batchMarks = allMarks.filter(mark => batchTasks.map(task => task._id).includes(mark.testId._id));
    //                 const totalMarks = batchMarks.reduce((sum, mark) => sum + mark.score, 0);
    //                 const averageMarks = batchMarks.length ? (totalMarks / batchMarks.length) : 0;
    //                 return { batchName: batch.name, averageMarks };
    //             });
    //             console.log(avgMarksData);
                
    //             setAvgMarks(avgMarksData);
    //         } else {
    //             toast.error(batchRes.data.message);
    //         }
    //     } catch (error) {
    //         toast.error(error.message || "Something went wrong while fetching data");
    //     } finally {
         
    //     }
    // };
    const barData = {        
        labels: avgMarks?.map(batch => batch.batchName),
        datasets: [
            {
                label: 'Average Marks',
                data: avgMarks?.map(batch => batch.averageMarks),
                backgroundColor: 'rgba(75,192,192,0.6)',
                barThickness: 40,
            }
        ]
    };

    return (
        <div>
          
                    <div>
                        <h2>Average Marks by Batch</h2>
                        <Bar data={barData} />
                    </div>
              
        </div>
    );
};

export default BatchGraph;
